// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum OrderRequestValidationStatus {
	OK = 1,
	Warning = 2,
	Error = 3,
}
